<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epg"> </p>
<p class="FMEP">Wars begin when you will,</p>
<p class="FMEP">but they do not end when you please.</p>
<p class="FMEPC"><span class="ePub-B-1">—NICCOLÒ MACHIAVELLI, </span><span class="ePub-BI">FLORENTINE HISTORIES,</span><span class="ePub-B-1"> BOOK III, CHAPTER 2</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?77d012cd